import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { PROMPT_TYPES } from '../../../../../../shared/Constants';
import BasicSelect from '../../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicTextArea from '../../../../../../shared/components/formComponents/groups/BasicTextArea';
import VerbButton, { FONT_AWESOME_ICON_WEIGHT, VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';

const visibilityOptions = [
    { name: 'Shown to all', value: PROMPT_TYPES.SHOWN_TO_ALL },
    { name: 'Shown to managers', value: PROMPT_TYPES.SHOWN_TO_MANAGERS }
];

export default class PromptsTab extends Component {
    static propTypes = {
        fields: PropTypes.any,
        changeFormValue: PropTypes.func,
        // eslint-disable-next-line react/no-unused-prop-types
        meta: PropTypes.object,
        errors: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            fields,
            changeFormValue,
            meta: { dirty },
            errors
        } = this.props;
        return (
            <div className={'trackSummary'}>
                <div className={'left-panel tab-spacing'}>
                    <div className={'row trackSections'}>
                        {/* <div className={'track-prompt-guidance'}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
              ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </div> */}
                    </div>
                </div>
                <div className={'col-9 right-panel track-prompts'}>
                    {fields.map((member, index, allFields) => (
                        <div className={'row'} style={{ marginTop: 20 }}>
                            <Field
                                name={`${member}.value`}
                                className={'col-6'}
                                placeholder={'Discussion Prompt'}
                                onChange={() =>
                                    changeFormValue({
                                        field: `prompts[${index}].value`,
                                        value: allFields.get(index).value
                                    })
                                }
                                component={BasicTextArea}
                            />
                            <Field
                                name={`${member}.showOption`}
                                className={'col-3 col-offset-1'}
                                options={visibilityOptions}
                                valueKey={'value'}
                                labelKey={'name'}
                                component={BasicSelect}
                            />
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIconWeight={FONT_AWESOME_ICON_WEIGHT.SOLID}
                                fontAwesomeIcon={'fa-trash'}
                                className={'ms-auto height-fit'}
                                onClick={() => fields.remove(index)}
                            />
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-angle-down'}
                                className={'height-fit'}
                                onClick={() => fields.move(index, index + (index === fields.length - 1 ? 0 : 1))}
                            />
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-angle-up'}
                                className={'height-fit'}
                                onClick={() => fields.move(index, index - (index > 0 ? 1 : 0))}
                            />
                        </div>
                    ))}
                    <div className={'form-validation-error'}>
                        {dirty && errors === 'Required prompt not filled' && errors}
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <VerbButton
                            buttonText={'+ ADD PROMPT'}
                            onClick={() => fields.push({ value: '', showOption: PROMPT_TYPES.SHOWN_TO_ALL })}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
